import { IBoneData, IEvent, ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { IGenericFamilySpine, ISpineTrackAnimation } from "./IGenericFamilySpine";
import { FillingPotParams } from "./FillinPotParams";
import { LogGroup, Point, Safe, Scale, Size, randomInclusive, shuffle } from "../../MyHelpers";
import { AudioManager, ITrack, Track } from "../../AudioManager";
import { IInterval } from "../../Context/Interval";
import { IRandomTimeout } from "../../Context/RandomTimeout";
import { ITimeout } from "../../Context/Timeout";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Settings } from "../../Settings";
import { SlotGameBet } from "../../api";
import { IFillinPotFamilyFactory, FillingPotFamilyFeatureFactory } from "./FamilyFactory";
import { FillingPotPhysical, IParticlesSaveData } from "./FillingPotPhysical";
import { BonusWillUpdateFillingPotFeature, IFillingPotIncrements } from "./IFillingPotIncrement";
import * as PIXI from 'pixi.js';
import { EventData } from '@pixi-spine/runtime-4.1';
import { IIncrementSavePerBet , IParticlesPerBetsSaved } from "./ILevelsPerBetSaved";
import { IRandomInterval } from "../../Context/RandomInterval";
import { service } from "../../services";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";

export class FamilyParticlesFeature extends IGenericFamilySpine {
    public override ViewPixiAPP(): PIXI.Container {
        throw new Error("Method not implemented.");
    }
    public override SetDataPostionPotGlobal(potCollectPosition: PotCollectPosition[]) {
        //throw new Error("Method not implemented.");
    }
    public override GetDataPositionPot(): PotCollectPosition[] {
        //throw new Error("Method not implemented.");
        return null
    }  
    public override ReelStops(winSymbolsReelStop : string[]): void {
        //throw new Error("Method not implemented.");
    }
    public override ParticlesDebugger() {
        this.matterjs.ParticlesDebugger();
    } 


    //protected view: HTMLElement = null;
    //protected params: FillingPotParams = null;
    protected logGroup: LogGroup = null;
    protected resid: ResourceIdentifier = null;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    protected restoreWebGlInterval: IInterval = null;
  
    protected availableLevelPerBet: Map<string, IParticlesPerBetsSaved> = new Map<string, IParticlesPerBetsSaved>();
    protected gameResourcesBasePath: string = null;
    //protected gameName: string = null;
    //protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
    //protected changeTrackSpineInterval: IRandomInterval = null;
    protected matterjs: FillingPotPhysical = null;
    //protected containerSpinnableReelsSpine: PIXI.Container = null;
    protected positionSpinnableReelsSpinePivotContainer: Size = null;
   
    protected audio: AudioManager = null;


    protected recoverCount: number = 0;
    protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;

    //protected intervalLevelRAAnimation: IInterval = null;
    protected restartStartIncrementLevelsOneTime: ITimeout = null;
    protected startRALevelLoop : ITimeout = null;
    protected intervalSRAPathDebugger : IInterval = null;
    protected timeOutCleanParticles : ITimeout = null;
    protected currentLevel = 0;
    //protected params: FillingPotParams;
    protected containerSpinnableReelsSpine: PIXI.Container<PIXI.DisplayObject>;    
    protected jsonSpine: ISkeletonData = null;
    protected spineHit: Spine = null;
    protected spineInitSize = new Size(Scale.W(1920), Scale.H(1080));   
    //protected containerParticlesHit: PIXI.Container = null;
    //protected enableSoundRA : boolean = false ; 
    protected backgroundLiveSpineTimeout: ITimeout = null;
   
    constructor(familyName : string , params: FillingPotParams , controlScalePoint : Point){
        super(params);
       
        this.familyType = familyName ;
        this.gameName = params.gameName;
        this.logGroup = params.logGroup.Add("FamilyParticles");
        this.resid = params.resid.Add("FamilyParticles");      

        //init bet levels and particles 
        params.initData.EnabledBets.forEach((b) => {

            this.availableLevelPerBet.set(
                `${this.gameName}_${b.Bet.TotalBetCents.InCents}`,    
                {                
                    TotalBet: b.Bet.TotalBetCents.InCents,
                    currentSpin : 0, 
                    particlesCount : 0,
                    particleSaveData : [],
                }
            )
        });




        //console.log(`${this.gameName}-LevelSavePerBet-:`,this.availableLevelPerBet);


        this.gameResourcesBasePath = params.gameResourcesBasePath;        
        this.audio = params.audio;

        this.matterjs = new FillingPotPhysical(this.gameName, this.logGroup, this.resid, params.systemContext , controlScalePoint);

        let indexAnimationColletpath : number = 0 ; 


        this.intervalSRAPathDebugger = params.systemContext.TimingContext().CreateInterval("pathSRA-Debugger",1000,()=>{            
            if(indexAnimationColletpath < this.animationArrayCollect.length){   
             let animationTrack = this.allAnimationMap.get(this.animationArrayCollect[indexAnimationColletpath]);
                this.PlayAnimationSpine(animationTrack.animationName,animationTrack.trackAnimationIndex,animationTrack.soundTrack); 
            indexAnimationColletpath++            
            }else {
                indexAnimationColletpath = 0;
                this.intervalSRAPathDebugger.Stop();
            }
        });

        // this.changeRandomAnimationSpineInterval = params.systemContext.TimingContext().CreateRandomTimeout("changeAnimationInterval", 60000, 300000, () => {
        //     if (this.animationArrayRASuffle.length > 0 && this.spineHit != null) {
               
        //         this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //         if (this.currentRandomAnimationIndex == this.animationArrayRASuffle.length - 1) {
        //             this.animationArrayRASuffle = shuffle(this.animationArrayRASuffle);
        //             //console.log("DoAnotherShuffledAnimation:", this.animationArrayRASuffle);
        //         }

        //         this.currentRandomAnimationIndex = (this.currentRandomAnimationIndex + 1) % this.animationArrayRASuffle.length;
        //         let animationTrack = this.allAnimationMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]);
        //         this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        //         //console.log("AnimationPlaying:", this.animationArrayRASuffle[this.currentRandomAnimationIndex]);
        //         let audio = this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex])
        //         if (audio != null && this.enableSoundRA == true) {
        //             audio.Play(false);
        //             //console.log("AnimationSoundPlaying:", this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]));
        //             this.enableSoundRA = false;

        //         }
        //         this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((animationTrack.duration * 1000) + 60000, (animationTrack.duration * 1000) + 300000);
        //         this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //         this.changeRandomAnimationSpineInterval.Start();
        //         audio = null;
        //     }
        // });   
        
        this.timeOutCleanParticles = params.systemContext.TimingContext().CreateTimeout("cleanParticles-Timeout", 3500, async () => {
            this.currentLevel = 0;
            this.currentSpin = 0;
            this.currentLevelPerBet.particleSaveData = [];
            this.currentLevelPerBet.particlesCount = 0;
            this.particlesCount = 0;            
            await service.api.storageSetOne(`${this.gameName}_${this.selectedBet.TotalBetCents.InCents}`, "0");
            //this.matterjs?.CleanParticlesBets();
        });

        // this.changeTrackSpineInterval = params.systemContext.TimingContext().CreateRandomInterval("changeAnimationInterval",60000 ,480000 , ()=>{
        //     if(this.enableSoundRA == false){
        //         this.enableSoundRA = true;
        //     }
        // });
        

     
        this.backgroundLiveSpineTimeout = params.systemContext.TimingContext().CreateTimeout("backgroundLiveSpineTimeout", 100, () => {
            for (let animIndexBG = 0; animIndexBG < this.animationArrayBackground.length; animIndexBG++){                
                let animationTrack = this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]);
                this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]).isActive = true;
                this.PlayAnimationSpine(this.animationArrayBackground[animIndexBG],animationTrack.trackAnimationIndex,animationTrack.soundTrack);
            }
        });

        params = null;
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {        
        await this.matterjs?.PrepareResources(resourceManager);      
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {        
        await this.matterjs?.ResourcesLoaded(resourceManager);
       
    }

    //protected currentRandomAnimationIndex: number = -1;
    protected currentRandomIDLEAnimationIndex: number = -1;   
    protected allAnimationMap: Map<string, ISpineTrackAnimation> = new Map<string, ISpineTrackAnimation>();
    protected allAnimationArray : string [] = [];
    protected startIndexRandomAnimation: number = null;
    //protected animationArrayRASuffle: string[] = [];
    //protected animationRAArray: string[] = [];
    //protected lastindexAnimInterval: number = -1;
    protected animationBreathTrack: ITrackEntry = null;
    protected countLevelAnimation : number = 0 ;
    protected animationArrayCollect: string[] = [];

    //create for the Family-Constructive
    protected levelIndex = 200;
    protected levelRAIndex = 300;
    //create anim for spine 
    //same for all family

    //create event for spine
    protected eventSpine = async (trackIndex: ITrackEntry, event: IEvent) => {
        // Check if the event name matches your desired trigger                   
        let eventdata = event as unknown as EventData;
        //stops animation when pathAnim its finished
        if (eventdata.stringValue == "pathStart") {
            //this.audio.Play(this.resid.ScopedResourceName("collectHitStartSound"));
            this.spineTrackMap.get("collectHitStartSound").Play();            
        }
        else if (eventdata.stringValue == "pathFinished") {
            //play sound for finish path collect anim                                                                                                  
            await this.IncrementParticles();  
            this.matterjs?.OnStartBigWinShow();          
        }       
        eventdata = null; 
        trackIndex = null;
    };

    
    protected countBonusAnim = 0;
    protected AnimComplete = (trackComplete: ITrackEntry) => {
        //const anim = trackComplete.animation;
        if (this.allAnimationMap.get(trackComplete.animation.name)?.loopAnimation == true) {           
            let trackAnimation = this.allAnimationMap.get(trackComplete.animation.name);
            this.PlayAnimationSpine(trackAnimation.animationName, trackComplete.trackIndex, trackAnimation.soundTrack, null, true, trackComplete);
           
        }
        else {
            if(trackComplete.trackIndex == 0 ) return 
            console.log(`trackAnimLoopDisable-${trackComplete.animation.name}:`, trackComplete);            
            this.spineHit?.state?.clearTrack(trackComplete.trackIndex);
            if(trackComplete.animation.name == "BN_BONUS"){
                this.matterjs?.StopsUpdatePhisical();       
                this.matterjs?.CleanParticlesBets() 
            }
        }
    }

    protected StartAnim = (trackComplete: ITrackEntry) => {  
    }



    protected animatioBreathName : string = null;
    protected animationArrayBackground: string[] = [];
    public override CreateAnimFamilyFeature(spineHit: Spine , app: PIXI.Application<HTMLCanvasElement> )  {
        this.spineHit = spineHit;

        //create Matter.js
        //if (this.familyType == "Family-Particles") {
            this.startBonusWin = false;
            this.matterjs.Create(app, spineHit)
            this.matterjs.OnCreatedMatterCallback = async () => {
                if (this.selectedBet != null) await this.SetBet(this.selectedBet);
            }
        //}

        // //Check if spine hit was create ok 
        //if (spineHit != null) 
        {           
            this.spineHit.state.data.skeletonData.animations.forEach((anim, index) => {

                let spineTrackAnimation : ISpineTrackAnimation = {
                    trackAnimationIndex : 0,
                    loopAnimation : false,
                    soundTrack : null,
                    duration : 0,
                    animationName : "",
                    isActive : false
                }

                                
                //this.allAnimationArray.push(anim);
                if (anim.name.includes("animationCollectPath_")) {
                    this.animationArrayCollect.push(anim.name);
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.trackAnimationIndex = index + this.collectStartTrackIndex;                    
                }

                else if (anim.name.includes("RA_")) {
                   return
                }
                else if (anim.name.includes("BG_")) {
                    this.animationArrayBackground.push(anim.name);
                    spineTrackAnimation.loopAnimation = true;
                    spineTrackAnimation.trackAnimationIndex = index + this.backgroundIndexAnim;
                }
                else if (anim.name.includes("IDLE_")) {
                    this.animatioBreathName = anim.name;                    
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                    spineTrackAnimation.loopAnimation = true;
                    spineTrackAnimation.animationName = anim.name;
                    spineTrackAnimation.isActive = true;                                                            
                }

                else if (anim.name.includes("LevelStartHit")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitSound");                                    
                }

                else if (anim.name.includes("LevelAnimation_Full_LevelStart")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitSound");   
                }
                
                else if (anim.name.includes("EXPECTATION")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack =  this.spineTrackMap.get("spineAnticipation");
                }

                else if (anim.name.includes("BN_BONUS")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitBonus");
                }

                else if (anim.name.includes("BN_START")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                    spineTrackAnimation.loopAnimation = false;
                    //spineTrackAnimation.soundTrack =  this.spineTrackMap.get("collectHitBonus");
                }

                spineTrackAnimation.duration = anim.duration;
                spineTrackAnimation.animationName = anim.name;
                this.allAnimationMap.set(anim.name, spineTrackAnimation);
            });

            if (this.allAnimationMap.has(this.animatioBreathName) == true){
                this.allAnimationMap.get(this.animatioBreathName).isActive = true;
                this.PlayAnimationSpine(this.animatioBreathName, this.trackIndexIDLE, null);    
                
            };

            if (this.animationArrayBackground.length > 0) {
                this.backgroundLiveSpineTimeout.Start();
            }


            
            let hasAll = true;

            for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++)
            {
                for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++)
                {
                    if (!this.allAnimationMap.has(`animationCollectPath_${reel}_${row}`))
                    {
                        hasAll = false;
                    }
                }
            }

            // if we don't have all animations for animationCollectPath, lets delete all and not use it
            if (!hasAll)
            {
                this.animationArrayCollect = [];
                for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++)
                {
                    for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++)
                    {
                        this.allAnimationMap.delete(`animationCollectPath_${reel}_${row}`);
                    }
                }
            }



            this.startIndexRandomAnimation = this.spineHit?.state?.data?.skeletonData?.animations?.findIndex(animation => animation.name.includes("RA_"));


            //this.animationArrayRASuffle = shuffle(this.animationArrayRASuffle);
            //arrayAnim = null;
            console.log("allAnimationMap:", this.allAnimationMap);
            //Create interval for RA animation 
            // if (this.animationArrayRASuffle.length > 0) {               
            //     this.changeRandomAnimationSpineInterval?.Start();
            //     this.changeTrackSpineInterval?.Start();
            // }


            // Add an event listener to the Spine animation           
            this.spineHit?.state?.addListener({
                event: this.eventSpine,
                complete: this.AnimComplete,
                start: this.StartAnim
            });

            this.SetMixAnimation();

        }
        //console.log("Spine-FamilyParticles-Created",this.resid.ID());       
    }

    protected SetMixAnimation() {
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "LevelStartHit", 0.5);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "EXPECTATION", 0.5);
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix("LevelStartHit", this.animatioBreathName, 0.5);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix("EXPECTATION", this.animatioBreathName, 0.5);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "BN_START", 0.5);
        if (this.allAnimationMap.has("BN_BONUS") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "BN_BONUS", 0.5);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has("BN_BONUS")) this.spineHit?.state.data.setMix("BN_START", "BN_BONUS", 0.5);
    }

    protected async IncrementParticles() {
        this.matterjs?.GenerateRandomParticle(false);

        if (this.allAnimationMap.has("LevelStartHit") == true && this.spineHit != null){                
            let animationTrack = this.allAnimationMap.get("LevelStartHit");
            this.PlayAnimationSpine(animationTrack.animationName,animationTrack.trackAnimationIndex,animationTrack.soundTrack)
        }
       
        //this.audio.Play(this.resid.ScopedResourceName("collectHitSound"), true );  
        this.spineTrackMap.get("collectHitSound").Play(false);                      
        this.particlesCount++;
        //SaverParticle
       await this.SaveCurrentIncrement();    
    }
   
    /** use for SetBet and change timeTrack per bet for Spine if you was played and hit some SRA */
    protected selectedBet : SlotGameBet = null;
    protected currentLevelPerBet: IParticlesPerBetsSaved = null;
    public async SetBet(selectedBet: SlotGameBet) {
        this.selectedBet = selectedBet;
        this.currentLevelPerBet = this.availableLevelPerBet.get(`${this.gameName}_${selectedBet.TotalBetCents.InCents}`); 
       await this.ParticlesBet()        
       await this.SaveCurrentIncrement();
    }

    protected async ParticlesBet() {

        if (this.currentLevelPerBet.particlesCount > 0) {
            this.matterjs.SetBet(this.currentLevelPerBet.particleSaveData);
            this.currentLevelPerBet.particleSaveData = this.matterjs?.GetParticlesSaved();
            return
        } else {

            let apiResult = await service.api.storageGetOne(`${this.gameName}_${this.selectedBet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            if (apiResult != null) this.matterjs?.SetBet(null, parseInt(apiResult));
            else { 
                //need init firt time this bet 
                this.matterjs.SetBet(this.currentLevelPerBet.particleSaveData);
                this.currentLevelPerBet.particleSaveData = this.matterjs?.GetParticlesSaved();
            }
            //this.SaveCurrentIncrement();              
            //console.log(`Level-SavedDB-CountParticles-${this.gameName}:`,apiResult);        
            this.currentLevelPerBet.particleSaveData = this.matterjs?.GetParticlesSaved();
        }
    }

    
    protected startBonusWin : boolean = false;
    public async StartBonusWin(bonusName:string) {      
        this.startBonusWin = true;
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.changeTrackSpineInterval?.Stop();       
        if (this.allAnimationMap.has("BN_BONUS") && this.spineHit?.state) {
            let animationTrack = this.allAnimationMap.get("BN_BONUS");           
            this.PlayAnimationSpine(animationTrack.animationName, this.trackIndexIDLE, animationTrack.soundTrack);
        }

        BonusWillUpdateFillingPotFeature.forEach(b => {
            if (b == bonusName) {
                if (this.spineHit != null) {
                    //this.spineTrackMap.get("collectHitBonus").Play(false);                      
                    this.matterjs.StartBonusWin();
                }                
                this.timeOutCleanParticles.Start();
                b = null;
            }
        });        
        await this.SaveCurrentIncrement();  
        
        if (this.allAnimationMap.has(this.animatioBreathName) == true) {
            this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0 , this.spineHit);
        };
    }
    //protected animationExpectation : ITrackEntry = null
    public StartAnticipationBegin() {      
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.changeTrackSpineInterval?.Stop();        
    
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spineHit != null) {            
            let trackAnimation = this.allAnimationMap.get("EXPECTATION");     
            this.allAnimationMap.get("EXPECTATION").isActive = true;
            this.PlayAnimationSpine(trackAnimation.animationName,trackAnimation.trackAnimationIndex,trackAnimation.soundTrack)
            //this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo(( trackAnimation.duration * 1000) + 60000, ( trackAnimation.duration * 1000) + 300000)
        }

        if (this.allAnimationMap.has(this.animatioBreathName) == true) {
            this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0, this.spineHit);
        }; 
    }

    public EndAnticipationBegin() {          
        //this.changeRandomAnimationSpineInterval?.Start();
        //this.changeTrackSpineInterval?.Start();              
    }

    protected collectStartTrackIndex = 50;
    protected trackIndexAnimSpecialGameConnected = 1;    
    protected backgroundIndexAnim = 20;
    protected trackIndexIDLE = 0;

    protected spinsForHitBonus : number = 50;
    protected currentSpin : number = 0;   
    protected percetageIncrementLevels : number = 0;
    protected particlesCount : number = 0;
   // protected randomAnimationIndex : number = 2;
    /** set new increment for change scale for part in spine */
    public StartIncrement(fillingPotIncrements: IFillingPotIncrements): void {
        //play animation path depends reel and row index 
        if (!this.spineHit )
        {
            // no spine
            return;
        }
        //let animationCollectPath : ITrackEntry = null;
        fillingPotIncrements.ScatterCordinates?.forEach(s => {
            const animationName = `animationCollectPath_${s.Reel}x${s.Row}`;
            if (!this.allAnimationMap.has(animationName)) 
            {
                // no animation
                return;
            }

            let trackAnim = this.allAnimationMap.get(animationName);
            this.PlayAnimationSpine(animationName,trackAnim.trackAnimationIndex,trackAnim.soundTrack,1.7);
        });
    }

    public async UpdateSpin() {        
        this.currentLevelPerBet.currentSpin++; 
        await this.SaveCurrentIncrement();          
    }

    /** save new increment per denom its missing add per pet */
    public async SaveCurrentIncrement() {
        //this.currentLevelPerBet.currentSpin = this.currentSpin;
        this.currentLevelPerBet.particlesCount = this.particlesCount;
        let particlesSaved = this.matterjs?.GetParticlesSaved();        
        if (particlesSaved.length > 0 ) {
            this.currentLevelPerBet.particleSaveData = particlesSaved;
            //console.log(`${this.gameName}-ParticlesSaveBetPerLevel-:`, this.availableLevelPerBet);     
            await service.api.storageSetOne(`${this.gameName}_${this.selectedBet.TotalBetCents.InCents}`, particlesSaved.length.toString());
        }
        particlesSaved = null;
    }

    /** pause loop anim*/
    public StopAnim(): void {
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.changeTrackSpineInterval?.Stop();        
        this.spineTrackMap.get("collectHitBonus").Stop();          
        if (this.allAnimationMap.has("BN_BONUS")) {
            this.allAnimationMap.get("BN_BONUS").isActive = false;
            this.allAnimationMap.get("BN_BONUS").loopAnimation = false;
        }
    }

    /** restart loop anim */
    public RestartAnim(): void {        
        this.matterjs?.StartUpdatePhisical();
        this.startBonusWin = false;
        //console.log("RESTART ANIM Funtion ");
    }

    public View(): HTMLElement {
        return null
    }

    public Update(): void {
        //if (this.familyType == "Family-Particles") {
            this.matterjs?.Update()            
        //};
    }

    public async LevelDebuggerTest() {
        this.currentLevel++
        //this.percetageIncrementFillingPot = 1;             
        await this.IncrementParticles();        
    }

    public PathDebuggerTest(command: string) {
        if (command == "pathsra") {
            let randomPath = this.animationArrayCollect.filter(anim => anim.includes("animationCollectPath_")).random();
            let animationTrack = this.allAnimationMap.get(randomPath);
            this.PlayAnimationSpine(animationTrack.animationName , animationTrack.trackAnimationIndex,animationTrack.soundTrack);            
        } else {
            if (this.intervalSRAPathDebugger.Running() != true) this.intervalSRAPathDebugger.Start();
        }
    }   

    protected startWinShow : boolean = false ;
    public OnStartBigWinShow(){
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.changeTrackSpineInterval?.Stop();     
      
        this.startWinShow = true;
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spineHit != null && this.startWinShow == true) {           
            let animationTrack = this.allAnimationMap.get("EXPECTATION");                
            this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        };
        //console.log("STOPS ANIM AND PLAY BONUS ");
        
        this.matterjs?.OnStartBigWinShow();

        if (this.allAnimationMap.has(this.animatioBreathName) == true) {
            this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0 , this.spineHit);
        };
    }    

    public OnEndBigWinShow(){               
        if (this.startWinShow == true) {          
            //this.changeRandomAnimationSpineInterval?.Start();
            //this.changeTrackSpineInterval?.Start();            
            this.startWinShow = false;         
        }
    }

    public override Destroy() {   
        //this.animationArrayRASuffle = [];
        this.animationArrayCollect = [];
        //this.animationRAArray = [];
        this.allAnimationArray = [];
        //this.lastindexAnimInterval = null;
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.changeTrackSpineInterval?.Stop();
        //this.currentRandomAnimationIndex = null;
        //this.spineHit = null;
        this.currentLevel = 0;        
        this.currentSpin = 0;
        this.animationBreathTrack = null;
        this.intervalSRAPathDebugger?.Stop();
        this.matterjs?.Destroy()
        //console.log("Family-Constructive-Particles-",this.resid.ID());
        this.startBonusWin = false;
    //     if (  this.spineHit.parent) {
    //         this.spineHit.parent.removeChild(  this.spineHit);
    //   }
    //   this.spineHit = null;
    } 

    public override AddTrack(track: ITrack,nameTrack : string ) {
        this.spineTrackMap.set(nameTrack,track);
    }  
    
    public override FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: RegExpMatchArray) {
        // this.changeRandomAnimationSpineInterval?.Stop();
        // this.changeTrackSpineInterval?.Stop();
        // let indexRA = parseInt(numberAnimToPlay[0]) - 1;
        // if (indexRA < this.animationRAArray.length) {
        //     console.log("FamilyParticles-AnimationRATOPlay:", this.animationRAArray[indexRA]);          
        //     let animationTrack = this.allAnimationMap.get(this.animationRAArray[indexRA]);
        //     this.PlayAnimationSpine(animationTrack.animationName,animationTrack.trackAnimationIndex,animationTrack.soundTrack)
        //     let audio = this.spineTrackMap.get(this.animationRAArray[indexRA])
        //     if(audio != null)audio.Play(false);    
        //     console.log("FamilyParticles-AnimationRATOPlay-Sound:", this.spineTrackMap.get(this.animationRAArray[this.currentRandomAnimationIndex]));
        //     setTimeout(() => {
        //         this.changeRandomAnimationSpineInterval.Start();
        //         this.changeTrackSpineInterval?.Start();              
        //     }, (animationTrack.duration * 1000) + 5500);
        // }else {
        //     console.log("RA_Anim Dose't exist , change index :  1 to 10 , availablesRA :" , this.animationRAArray.length);
        // }
    }

    public override GetCurrentLevels(): IIncrementSavePerBet {
        return {
            familyParticles: this.availableLevelPerBet,
            familyConstructive: null,
            familyConstrutiveMultPot : null
        }
    }

    public SetCurrentFromBaseGameLevels(incrementSavePerBet : IIncrementSavePerBet){
        if(incrementSavePerBet != null )this.availableLevelPerBet = incrementSavePerBet.familyParticles;
    }

    protected PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, soundTrack: ITrack, speedAnimation: number = null, loopAnim: boolean = false, trackComplete?: ITrackEntry) {
        if (loopAnim == true && !trackComplete == true ) {
            trackComplete.trackTime = 0;
            soundTrack?.Play();
            return
        }
        else  {
            this.spineHit?.state?.addEmptyAnimation(trackAnimationIndex , 0 , 0);
            this.spineHit?.state?.setEmptyAnimation(trackAnimationIndex, 0);
            let trackAnimation = this.spineHit?.state?.setAnimation(trackAnimationIndex,nameAnimation,false);
            if (trackAnimation && speedAnimation != null) {
                trackAnimation.timeScale = speedAnimation;
            }
            //this.allAnimationMap.get(nameAnimation).trackAnimationIndex = trackAnimationIndex;
            soundTrack?.Play();
        }
    }

    public override async  RamclearFillingPot(selecteBet: SlotGameBet) {
        this.matterjs.StopsUpdatePhisical();
        this.matterjs.CleanParticlesBets();            
        this.availableLevelPerBet.forEach((b) => {
            //await service.api.storageDeleteOne(`${this.gameName}_${this.potName}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            let betFind = this.availableLevelPerBet.get(`${this.gameName}_${selecteBet.TotalBetCents.InCents}`)
            if (betFind == null) return
            betFind.particleSaveData = [];
            betFind.currentSpin = 0;
            betFind.particlesCount = 0;
        });

        
        //await this.ResetPoseSpine();
        console.log(`Ramclear-ParticlesFillingPotComplete-${this.gameName}`,this.spineHit);        
        //if(this.spineHit == null) return
        await this.SetBet(selecteBet);
    }
}
